/**
 * =============================================================================
 * skins.js — SKIN & WARNA KOSMETIK SEMUT
 * =============================================================================
 * Semua skin HANYA visual — TIDAK mempengaruhi RNG / peluang menang.
 * Digambar di ant.js → _drawSkin().
 * =============================================================================
 */

/* ---------------------------------------------------------------------------
 * DAFTAR SKIN
 * id     = kunci internal (disimpan di participant.skinId)
 * label  = nama tampilan UI (Bahasa Indonesia)
 * emoji  = ikon kecil di kartu menu / tabel hasil
 * --------------------------------------------------------------------------- */
export const SKINS = [
  { id: 'cowboy', label: 'Koboi', emoji: '🤠' },
  { id: 'police', label: 'Polisi', emoji: '👮' },
  { id: 'chef', label: 'Koki', emoji: '👨‍🍳' },
  { id: 'pirate', label: 'Bajak Laut', emoji: '🏴‍☠️' },
  { id: 'viking', label: 'Viking', emoji: '🪓' },
  { id: 'astronaut', label: 'Astronot', emoji: '🚀' },
  { id: 'ninja', label: 'Ninja', emoji: '🥷' },
  { id: 'santa', label: 'Santa', emoji: '🎅' },
  { id: 'grad', label: 'Wisuda', emoji: '🎓' },
  { id: 'king', label: 'Raja', emoji: '👑' },
  { id: 'wizard', label: 'Penyihir', emoji: '🧙' },
  { id: 'superhero', label: 'Superhero', emoji: '🦸' },
  { id: 'hoodie', label: 'Hoodie', emoji: '👕' },
  { id: 'denim', label: 'Jaket Denim', emoji: '🧥' },
  { id: 'crown', label: 'Mahkota', emoji: '👑' },
  { id: 'straw', label: 'Topi Jerami', emoji: '👒' },
  { id: 'hardhat', label: 'Helm Proyek', emoji: '⛑️' },
  { id: 'headphones', label: 'Headphone', emoji: '🎧' },
  { id: 'glasses', label: 'Kacamata', emoji: '👓' },
  { id: 'mustache', label: 'Kumis', emoji: '🥸' },
  { id: 'fairy', label: 'Sayap Peri', emoji: '🧚' },
  { id: 'flower', label: 'Mahkota Bunga', emoji: '🌸' },
];

/**
 * randomSkinId()
 * Pilih id skin acak dari daftar SKINS.
 */
export function randomSkinId() {
  return SKINS[Math.floor(Math.random() * SKINS.length)].id;
}

/**
 * getSkin(id)
 * Cari data skin by id; fallback ke skin pertama jika tidak ketemu.
 */
export function getSkin(id) {
  return SKINS.find((s) => s.id === id) || SKINS[0];
}

/**
 * randomBodyColor()
 * Hasilkan warna tubuh HSL acak dari palette coklat/oranye semut.
 * Return: { h, s, l }
 */
export function randomBodyColor() {
  const palettes = [
    [18, 55, 38],
    [12, 62, 32],
    [28, 70, 42],
    [8, 45, 28],
    [35, 60, 45],
    [5, 50, 35],
    [22, 40, 30],
    [40, 65, 48],
    [15, 48, 25],
    [30, 55, 40],
  ];
  const [h, s, l] = palettes[Math.floor(Math.random() * palettes.length)];
  const jitter = () => (Math.random() - 0.5) * 16;
  return {
    h: (h + jitter() + 360) % 360,
    s: Math.max(30, Math.min(80, s + jitter())),
    l: Math.max(22, Math.min(55, l + jitter())),
  };
}

/**
 * colorCss(c, dl, ds, a)
 * Ubah objek {h,s,l} jadi string CSS hsl/hsla.
 * dl = delta lightness, ds = delta saturation, a = alpha 0..1
 */
export function colorCss(c, dl = 0, ds = 0, a = 1) {
  const s = Math.max(0, Math.min(100, c.s + ds));
  const l = Math.max(0, Math.min(100, c.l + dl));
  return a < 1 ? `hsla(${c.h}, ${s}%, ${l}%, ${a})` : `hsl(${c.h}, ${s}%, ${l}%)`;
}
